import { get } from '@/api/request'

const silentConfig = { silent: true }

export function getCustomerStatisticsSummary(params) {
  return get('/customer/statistics/summary', params, silentConfig)
}

export function getOrderStatisticsSummary(params) {
  return get('/order/statistics/summary', params, silentConfig)
}

export function getPaymentStatisticsSummary(params) {
  return get('/payment/statistics/summary', params, silentConfig)
}

export function getReferrerIncomeStatisticsSummary(params) {
  return get('/commission/referrer-income/statistics/summary', params, silentConfig)
}
